import { useBloc } from "@blac/react";
import { Modal, type ModalHandle } from "@9amhealth/shared";
import styled from "@emotion/styled";
import type { FC } from "react";
import React, { useEffect, useRef } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import translate from "src/lib/translate";
import AppPageTitle from "src/ui/components/AppPageTitle/AppPageTitle";
import AppSubPage from "src/ui/components/AppSubPage/AppSubPage";
import CustomSuspense from "src/ui/components/CustomSuspense/CustomSuspense";
import OverlayBackButton from "src/ui/components/StyledComponents/OverlayBackButton";
import DataHubCubit from "../DataHub/DataHubCubit";
import UserLabResults from "../UserLabResults/UserLabResults";

const LabBundleModalContent = styled.div`
  padding: 1rem 1.6rem calc(var(--safe-area-inset-bottom) + 2rem);
`;

const Async = {
  ListLabsByCodes: React.lazy(
    async () => import("src/ui/components/ListLabsByCodes/ListLabsByCodes")
  ),
  ListLabsFromBundle: React.lazy(
    async () =>
      import("src/ui/components/ListLabsFromBundle/ListLabsFromBundle")
  )
};

export const LABS_BASE_PAGE_URL = "/app/lab-results";

const LabBundleModal: FC = () => {
  const navigate = useNavigate();
  const modalRef = useRef<ModalHandle>(null);

  return (
    <Modal
      ref={modalRef}
      isOpen
      variant="sheet"
      onDidDismiss={() => navigate(LABS_BASE_PAGE_URL, { replace: true })}
    >
      <LabBundleModalContent>
        <CustomSuspense>
          <Async.ListLabsFromBundle
            onRequestClose={() => modalRef.current?.dismiss()}
          />
        </CustomSuspense>
      </LabBundleModalContent>
    </Modal>
  );
};

const LabResultsDataSubPageRouter: FC = () => {
  const [, { clearApiCache }] = useBloc(DataHubCubit);

  useEffect(() => {
    // Clear cache when unmounting
    return () => clearApiCache();
  }, []);

  return (
    <Routes>
      <Route
        path={`/list-codes/:codes`}
        element={
          <AppSubPage>
            <OverlayBackButton show fallbackUrl={LABS_BASE_PAGE_URL} />
            <AppPageTitle title={translate("recordedData")}></AppPageTitle>
            <nine-spacer s={"sm"}></nine-spacer>
            <CustomSuspense>
              <Async.ListLabsByCodes />
            </CustomSuspense>
          </AppSubPage>
        }
      />

      <Route path="/bundle" element={<LabBundleModal />} />

      <Route
        path={"*"}
        element={
          <>
            <UserLabResults />
          </>
        }
      />
    </Routes>
  );
};

export default LabResultsDataSubPageRouter;
